const cities = [   
  { name: "Tunis", lat: 36.8065, lon: 10.1815 },
  { name: "Ariana", lat: 36.8625, lon: 10.1956 },
  { name: "Béja", lat: 36.7256, lon: 9.1817 },
  { name: "Ben Arous", lat: 36.7531, lon: 10.2189 },
  { name: "Bizerte", lat: 37.2744, lon: 9.8739 },
  { name: "Gabès", lat: 33.8815, lon: 10.0982 },
  { name: "Gafsa", lat: 34.425, lon: 8.7842 },
  { name: "Jendouba", lat: 36.5011, lon: 8.7802 },
  { name: "Kairouan", lat: 35.6781, lon: 10.0963 },
  { name: "Kasserine", lat: 35.1676, lon: 8.8365 },
  { name: "Kébili", lat: 33.7044, lon: 8.969 },
  { name: "Kef", lat: 36.1826, lon: 8.7143 },
  { name: "Mahdia", lat: 35.5047, lon: 11.0622 },
  { name: "Manouba", lat: 36.809, lon: 10.0956 },
  { name: "Médenine", lat: 33.3549, lon: 10.5055 },
  { name: "Monastir", lat: 35.7643, lon: 10.8113 },
  { name: "Nabeul", lat: 36.451, lon: 10.7357 },
  { name: "Sfax", lat: 34.7398, lon: 10.76 },
  { name: "Sidi Bouzid", lat: 35.0382, lon: 9.4858 },
  { name: "Siliana", lat: 36.0846, lon: 9.3708 },
  { name: "Sousse", lat: 35.8256, lon: 10.636 },
  { name: "Tataouine", lat: 32.9297, lon: 10.4518 },
  { name: "Tozeur", lat: 33.9197, lon: 8.1335 },
  { name: "Zaghouan", lat: 36.4029, lon: 10.1429 },
];

export default cities

